// Lo que todavía se está analizando, TODO JUNTO en una sola sección
// (ADR-2026-10-02-onboarding-v2-tablero-con-cumbre): cuánto va y qué falta, sin explicar
// cada parte ni partirla en tarjetas. Cada parte sale de acá cuando está lista y aparece
// arriba como su propia sección. El texto va en neutro
// (ADR-2026-10-02-onboarding-v2-analisis-en-neutro). A mano todo llega junto, así que no
// cuenta partes: la barra va y viene y ninguna parte figura "ahora".

export function AnalisisEnCurso(p: {
  /** Las partes que faltan, ya con su nombre, en orden. La primera es la que está en curso. */
  pendientes: Array<{ id: string; etiqueta: string }>;
  listos: number;
  total: number;
  manual: boolean;
}) {
  const porcentaje = Math.round((p.listos / Math.max(1, p.total)) * 100);
  return (
    <section className="om-en-curso" aria-live="polite" aria-busy="true">
      <div className="om-en-curso__dentro">
        <header className="flex items-center gap-3">
          <span className="om-en-curso__radar" aria-hidden="true">
            <span className="material-symbols-rounded">{p.manual ? 'auto_awesome' : 'travel_explore'}</span>
          </span>
          <div className="min-w-0 flex-1">
            <h2 className="text-[16px] font-extrabold leading-tight text-[#02062B]">
              {p.manual ? 'Creando tu marca con lo que nos contaste' : 'Leyendo tu web para armar tu marca'}
            </h2>
          </div>
          {!p.manual && (
            <span className="shrink-0 text-[13px] font-bold tabular-nums text-[#1644EB]">
              {p.listos} de {p.total}
            </span>
          )}
        </header>

        {p.manual ? (
          <div className="om-en-curso__barra" role="progressbar" aria-label="Creando tu marca">
            <span className="is-indeterminada" />
          </div>
        ) : (
          <div
            className="om-en-curso__barra"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={p.total}
            aria-valuenow={p.listos}
            aria-label="Avance del análisis"
          >
            <span style={{ width: `${Math.max(6, porcentaje)}%` }} />
          </div>
        )}

        <ul className="flex flex-wrap gap-2" aria-label={p.manual ? 'Lo que se está creando' : 'Lo que falta'}>
          {p.pendientes.map((x, i) => (
            <li key={x.id} className={`om-en-curso__chip ${i === 0 && !p.manual ? 'is-ahora' : ''}`}>
              <span className="om-en-curso__punto" aria-hidden="true" />
              {x.etiqueta}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default AnalisisEnCurso;
